import React from "react";
import PropTypes from "prop-types";
import { Input } from "antd";

@autobind
/**
 *
 */
export default class Base extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    required: false,
    disabled: false,
  };

  /**
   *
   * @return {Boolean}
   * @protected
   */
  get _grouped() {
    return false;
  }

  /**
   *
   * @return {XML|null}
   * @protected
   */
  get _props() {
    return this.props;
  }

  /**
   *
   * @return {XML|null}
   * @protected
   */
  get _prefix() {
    return null;
  }

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    return <input />;
  }

  /**
   *
   * @return {XML|null}
   * @protected
   */
  get _suffix() {
    return null;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const COMPONENT = this._component;
    const COMPONENT_PROPS = COMPONENT.props;
    const PROPS = this.props;

    const COMPONENTS = [
      this._prefix && React.cloneElement(this._prefix, { key: "0" }),
      React.cloneElement(COMPONENT, {
        ...this._props,
        key: "1",
        onChange: COMPONENT_PROPS.onChange || PROPS.onChange,
        id: PROPS.name,
        style: { width: "100%", ...COMPONENT_PROPS.style, ...PROPS.style },
      }),
      this._suffix && React.cloneElement(this._suffix, { key: "2" }),
    ].compact();

    if (COMPONENTS.length > 1) {
      if (this._grouped) {
        return (
          <Input.Group compact>
            {COMPONENTS}
          </Input.Group>
        );
      }

      return (
        <div>
          {COMPONENTS}
        </div>
      );
    }

    return COMPONENTS.first();
  }
}
